import React from 'react';
import PageSkeleton from "./PageSkeleton";
import {Tabs} from "antd";
import DevLicHistory from "../fragments/DevLicHistory";
import SignedExtensionHistory from "../fragments/SignedExtensionHistory";


const items = [
    {
        key: '1',
        label: 'Generated Licenses',
        children: (<DevLicHistory/>),
    },
    {
        key: '2',
        label: 'Signed Extensions',
        children: (<SignedExtensionHistory/>),
    }
];

const AuditHistory = () => {


    return (
        <PageSkeleton
            title="Audit History"
            description="View past events like generated development licenses, as well as extension signing events. This page can only be accessed by administrators."
        >
            <Tabs defaultActiveKey="1" type="line" items={items} />
        </PageSkeleton>
    );
};

export default AuditHistory;